import * as React from "react";

import classNames from "classnames";

import GenS3FileUploader from "./S3MediaAssetUploader";

const acceptedTypesByMediaType = {
  "image": "image/*",
  "audio": "audio/*",
  "video": "video/mp4,video/*",
};

interface GenMediaUploadButtonProps {
  onError?: (error: string) => void;
  documentId: number;
  mediaType: MediaType;
  onSuccess: () => void;
  mediaOptions?: {is_silent: true};
  titleEnding?: string;
  editState: EditState;
}

interface GenMediaUploadButtonState {
  progressPercent?: number;
}

export default class GenMediaUploadButton extends React.Component<GenMediaUploadButtonProps, GenMediaUploadButtonState> {
  constructor(props: GenMediaUploadButtonProps) {
    super(props);

    this.state = {};
  }

  onUploadProgress = (progressEvent: number) => {
    this.setState({progressPercent: progressEvent});
  };

  onUploadError = (error: string) => {
    const {
      onError,
    } = this.props;

    console.log("ERROR:", error);
    alert("Error Uploading");

    if (onError) { onError(error); }
    this.setState({progressPercent: undefined});
  };

  onUploadFinish = () => {
    const {
      onSuccess,
    } = this.props;

    if (onSuccess) { onSuccess(); }
    this.setState({progressPercent: undefined});
  };

  render() {
    const {
      mediaType,
      titleEnding="",
      documentId,
      mediaOptions,
    } = this.props;

    const {
      progressPercent,
    } = this.state;

    const hasProgress = typeof(progressPercent) === "number";
    const uploadID = `upload_${mediaType}${titleEnding}`;

    return (
      <span className="doc-media-upload-button">
        <label htmlFor={uploadID} className={classNames("bg-sky-600 hover:bg-sky-500 p-2 button", {disabled: hasProgress})}>
          {hasProgress ? "Uploading" : `Upload New ${titleEnding}`}

          <GenS3FileUploader
            id={uploadID}
            signingUrl="/media_assets/signed_url"
            accept={acceptedTypesByMediaType[mediaType]}
            onProgress={this.onUploadProgress}
            onError={this.onUploadError}
            onFinish={this.onUploadFinish}
            documentId={documentId}
            mediaOptions={mediaOptions}
            mediaType={mediaType}
          />
        </label>
        {hasProgress && (
          <div className="progress progress-striped active">
            <div className="bar" style={{width: `${progressPercent * 0.95}%`}} />
          </div>
        )}
      </span>
    );
  }
}
